import { Ticket } from '@/ticket/api/types';
import {
  UpdateTicketParameters,
  updateTicket,
} from '@/ticket/api/update-ticket';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateTicketOptions {
  onSuccess?: (ticket: Ticket) => void;
}

export function useUpdateTicket(key: string, options?: UpdateTicketOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (parameters: UpdateTicketParameters) => {
      return updateTicket(key, parameters);
    },
    onSuccess: async ({ ticket }) => {
      await queryClient.invalidateQueries({ queryKey: ['ticket', key] });

      options?.onSuccess?.(ticket);
    },
  });
}
